<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="140px">
          <el-form-item label="天数:">
            <el-input-number v-model="queryParam.searchDay" ></el-input-number>
          </el-form-item>
          <el-form-item label="剩余课时:">
            <el-input-number v-model="queryParam.remTimes" ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>

      </div>
      <div>
        <el-button type="danger" size="medium" class="operator-btn3" style="width: 120px;" icon="el-icon-guide" @click="handleAddTask()">添加任务表</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="540"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @row-click="rowClick"
                @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="userPhone" label="卡号" width="120"></el-table-column>
        <!--<el-table-column prop="lessonTemplateType" label="业务类型" width="100"></el-table-column>-->
        <el-table-column prop="useTypeDes" label="使用类型" width="90"></el-table-column>
        <el-table-column prop="cardName" label="卡类型" width="90"></el-table-column>
        <!--<el-table-column prop="userName" label="家长" ></el-table-column>-->
        <el-table-column prop="childName" label="会员" width="90" ></el-table-column>
        <el-table-column prop="monthC" label="月龄" width="50"></el-table-column>
        <el-table-column prop="childTypeDes" label="婴儿类型" width="90" ></el-table-column>

        <el-table-column prop="totalLesssonCountDes" label="总课时(正价/赠送)" width="120"></el-table-column>
        <!--<el-table-column prop="level" label="等级" width="90" ></el-table-column>-->
        <el-table-column prop="remainingClassDes" label="剩余课时" width="110" ></el-table-column>
        <el-table-column prop="totalPay" label="金额" width="70"></el-table-column>
        <!--<el-table-column prop="payTime" label="支付时间" ></el-table-column>-->
        <el-table-column prop="cardStartTime" label="生效时间" width="140"></el-table-column>
        <el-table-column prop="cardEndTime" label="过期时间"  width="140"></el-table-column>
        <el-table-column prop="valDay" label="有效期" width="90" ></el-table-column>
        <el-table-column prop="statuDes" label="状态"  width="130"></el-table-column>
        <el-table-column prop="remark" label="购卡备注" ></el-table-column>
        <el-table-column prop="taskFollowNote" label="任务备注" ></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>

  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {ECardUseType, EChildGender, EUserBuyCardStatu, getEnumDesByV} from "../../../utils/enumsUtil";
  import enumsUtil from "../../../utils/enumsUtil";
  import messageUtils from "../../../utils/messageUtils";
  import {queryBdVIPWillInvalied} from "../../../api/bd/BaseData";
  import timeUtils from "../../../utils/timeUtils";

  export default {
    components: {},
    data() {
      return {
        listLoading: true,
        queryParam:{
          searchDay:7,
          remTimes:10,//剩余次数
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },


        //表单结果
        tableData: [
        ],
        selectRow:null,

      }
    },
    created(){
      this.flechList();
    },
    mounted() {
    },
    methods: {

      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdBS(),
          day: this.queryParam.searchDay,
          remTimes:this.queryParam.remTimes,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        const loading = this.myLoading("正在查询，请稍后！！！");
        queryBdVIPWillInvalied(param).then(response =>
        {
          loading.close();
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        let now = new Date();
        for (let i = 0;i< list.length;++i){

          let totalLesssonCountDes =(list[i].totalLesssonCount +list[i].totalGiveCount)+ "("+  list[i].totalLesssonCount + "/" +list[i].totalGiveCount +")";
          let remainingClassDes =  (list[i].remainingClass+list[i].remainingGiveCount) + "(" + list[i].remainingClass + "/" +list[i].remainingGiveCount+")";
          let childTypeDes = "";
          if (list[i].childType == 1) {
            childTypeDes = "婴儿";
          }else if (list[i].childType == 2){
            childTypeDes = "幼儿";
          }
          let startV = list[i].cardStartTime;
          let cardSt = new Date(list[i].cardStartTime);
          if (cardSt.getTime() < now.getTime()){
            startV = now;
          }
          else {
            startV = cardSt;
          }
          let valDay = timeUtils.getDaysBetween(startV,list[i].cardEndTime ) +1;
          if (valDay<=0){
            valDay = "已过期"
          }
          let statuDes = list[i].statu;
          statuDes =  EUserBuyCardStatu(list[i].statu)
          let useTypeDes = getEnumDesByV(list[i].useType,ECardUseType())
          let data = {
            number : i+1 ,
            id: list[i].id,
            childId:list[i].childId,
            userId:list[i].userId,
            payTime: list[i].payTime,
            cardStartTime:list[i].cardStartTime,
            // lessonTemplateType:this.getBuyCardBusenss(list[i].storeLessonCardId),
            cardEndTime : list[i].cardEndTime,
            valDay:valDay,
            storeLessonCardId: list[i].storeLessonCardId,
            totalPay: list[i].totalPay,
            totalLesssonCount :list[i].totalLesssonCount,
            totalGiveCount :list[i].totalGiveCount,
            remainingClass:list[i].remainingClass,
            remainingGiveCount:list[i].remainingGiveCount,
            monthC:list[i].monthC,
            childTypeDes:childTypeDes,
            // level:getLevelDes(list[i].level),
            totalLesssonCountDes :totalLesssonCountDes,

            remainingClassDes :remainingClassDes,
            childName:list[i].childName,
            remark:list[i].remark,
            cardName: list[i].cardName,
            userName: list[i].userName,
            userPhone:list[i].phoneNumber,
            statu:list[i].statu,
            statuDes:statuDes,
            useType:list[i].useType,
            useTypeDes:useTypeDes,
            taskFollowNote:list[i].useType,
          };
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },

      rowClick(row, column, event){
        this.selectRow = row;
      },
      handleCheckSelect(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        return true;
      },


      onBtnCreate(){
        this.visibleDlgAdd = false;
        this.flechList();
      },
      onBtnCancel(){
        this.visibleDlgAdd = false;
      },
      onBtnOKBuyCard(){
        this.showAddCardDlg = false;
        this.refreshCard = new Date().getTime()

      },
      handleUpdateChild(){
        this.visibleDlgUpdateChildInfo = false;
        this.selectRow = null;
        this.flechList();
      },
      onBtnCancelUpdate(){
        this.visibleDlgUpdateChildInfo = false;
      },


      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleBookLesson(){
        if (!this.handleCheckSelect()){
          return;
        }
        this.addRefresh = new Date().getTime();
        this.visibleDlgBook = true;
      },


      handleCreateOne(){
        this.addRefresh = new Date().getTime()
        this.visibleDlgAdd = true;
      },
      handleByLesson(){
        this.showAddCardDlg = true;
        this.refreshCard = new Date().getTime()

      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },
      onBookSuccess(){
        this.visibleDlgBook = false;
      },

      onUpdateChildInfoShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.updateChildId  = this.selectRow.id

        this.visibleDlgUpdateChildInfo = true;

        this.updateRefresh = new Date().getTime();

      },

      /**
       * 添加线索
       */
      handleAddClueDig(){
        if (!this.handleCheckSelect()){
          return;
        }

        this.clueInfo = {
          childId :this.selectRow.id,
          userId :this.selectRow.userId,
          childName:this.selectRow.childName,
          childPetName:this.selectRow.childPetName,
          userPhone:this.selectRow.phoneNumber,
        }
        this.visibleDlgAddClue = true;

      },

      onCreateClueSuccess(){
        this.visibleDlgAddClue = false;
      },

      handleBuy(){
        this.visibleDlgBuyExpCard = false;
        this.flechList();
      },

      onBuyExpCardShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.buyExpCardChild = {
          name :this.selectRow.childName,
          userPhone:this.selectRow.phoneNumber,
          userId:this.selectRow.userId,
        }

        this.visibleDlgBuyExpCard = true;
        this.refreshBuyExpCard = new Date().getTime();

      },

      onChnageExpCardShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.changeExpCardChild = {
          name :this.selectRow.childName,
          userPhone:this.selectRow.phoneNumber,
          userId:this.selectRow.userId,
        }

        this.visibleDlgChangeExpCard = true;
        this.refreshChangeExpCard = new Date().getTime();

      },

      handleChange(){
        this.visibleDlgChangeExpCard = false;
        this.flechList();
      },

      handleAddTask(){
        let data = {
          taskType: 2,
          pList:[],
        }
        let pList = data.pList;
        for (let i = 0;i<this.multipleSelection.length;++i){
          pList.push({childName:this.multipleSelection[i].childName,userId:this.multipleSelection[i].userId,phoneNumber:this.multipleSelection[i].userPhone})
        }
        this.$router.push({path: '/myStore/AddWorkerTask',query:data})

      }

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/base-data/bd-vip-will-invalied/indexBs.vue